import { connect } from "react-redux";

import { userLogoutAction } from "../model/Benutzer";

import Navizeile from "./Navizeile";

const NO_RIGHTS = {
	overview: false,
	analytics: false,
	energy_balancing: false,
	maintenance: false,
	errors: false,
	settings: false
};

const ALL_RIGHTS = {
	overview: true,
	analytics: true,
	energy_balancing: true,
	maintenance: true,
	errors: true,
	settings: true
};

const stateToRights = (state) => {
	/*
	 * nicht eingelogt -> darf nix
	 */
	if (!state.user.isAuthorized)
		return NO_RIGHTS;

	/*
	 * schreibrecht -> darf alles
	 */
	if (state.user.canWrite)
		return ALL_RIGHTS;

	/*
	 * sonst, versuchen auszuwerten
	 */
	let result = state.settings.rights[state.user.demoOnly ? "demo" : "read"];
	if (!result)
		result = NO_RIGHTS;

	return result;
}

export default connect(state => ({
	disabled: !state.user.isAuthorized,
	location: state.router.location,
	rights: stateToRights(state)
}), dispatch => ({
	logout: dispatch(userLogoutAction())
}))(Navizeile);
